import React, { useEffect, useReducer, useState } from "react";
import OTPInput from "react-otp-input";
import Reducer from "../../utils/Reducer";
import {
  ADMIN_FORGET_PASSWORD,
  ADMIN_GET_OTP,
  ADMIN_VALIDATE_OTP,
  CMS_BASE_URL,
  EMAIL_VERIFICATION,
  EMAIL_VERIFICATION_OTP,
  FORGET_PASSWORD,
  GET_OTP,
  VALIDATE_OTP,
} from "../../utils/APIEndPoints";
import { CallAPI } from "../../utils/apiActions";
import validationUtility from "../../utils/Validation";
import { LABEL } from "../../utils/constant";
import { showToast } from "../../helper/toastHelper";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useDashboard from "../../hooks/useDashboard";
import OtpView from "../OtpView";
import useAuth from "../../hooks/useAuth";
import { delay } from "lodash";
import {
  clearEmailVerificationFlowStorage,
  getPendingEmailVerificationPlan,
} from "../../utils/emailVerificationFlow";

const initState = {
  varifivationStatus: false,
  otp: "",
  password: "",
  confirmPassword: "",

  otpErr: "",
  passwordErr: "",
  confirmPasswordErr: "",

  passEyeShow: false,
  confirmPassEyeShow: false,

  loading: false,
};

function ResetPassword({ ...props }) {
  console.log(props, "propspropsprops");
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const parentAgency = searchParams.get("agency") || null;
  const { companyInfo, isEmailVerified, updateEmailVerified, me } = useAuth();
  const { planPurchase, setPlanPurchase } = useDashboard();
  const pendingPlan = getPendingEmailVerificationPlan();

  const planId = searchParams.get("planId") || pendingPlan?.planId || null;
  const userId = searchParams.get("userId") || pendingPlan?.userId || null;
  const promotionCode =
    searchParams.get("promotionCode") ?? pendingPlan?.promotionCode ?? "";
  const returnUrl =
    searchParams.get("returnUrl") ||
    pendingPlan?.returnUrl ||
    `${process.env.REACT_APP_FRONTEND_BASE_URL}payment-status`;
  const [currentPlan, setCurrentPlan] = useState(undefined);

  // const { planPurchase, setPlanPurchase } = useDashboard(); //emai_verification -----> By Sharmishtha
  const [state, dispatch] = useReducer(Reducer, initState);
  const [verification, setVerification] = useState({
    email: false,
    phone: false,
  });
  const email =
    localStorage.getItem("email-verify") ||
    localStorage.getItem("reset-verify-mail") ||
    localStorage.getItem("admin-reset-verify-mail") ||
    "";
  const VALIDATE_OTP_URL = !isEmailVerified
    ? EMAIL_VERIFICATION
    : props.userType == "user"
      ? VALIDATE_OTP
      : ADMIN_VALIDATE_OTP;
  const GET_OTP_URL = props.userType == "user" ? GET_OTP : ADMIN_GET_OTP;
  const FORGET_PASSWORD_URL =
    props.userType == "user" ? FORGET_PASSWORD : ADMIN_FORGET_PASSWORD;
  const EMAIL_VERIFICATION_RESET_PASSWORD = EMAIL_VERIFICATION_OTP;
  // const otp = localStorage.getItem("reset-pass-otp") || ""

  console.log("registerdata--", VALIDATE_OTP_URL);

  //   EMAIL_VERIFICATION // fresh sighup time
  // VALIDATE_OTP //reset password time
  // ADMIN_VALIDATE_OTP // super adminreset password time

  const handleFormInput = (e) => {
    if (
      e.target.value == null ||
      e.target.value == "" ||
      e.target.value == undefined
    ) {
      dispatch({
        type: "SETDATA",
        payload: {
          name: e.target.name + "Err",
          value: `${e.target.name} is required`,
        },
      });
    } else {
      dispatch({
        type: "SETDATA",
        payload: { name: e.target.name + "Err", value: "" },
      });
    }
    dispatch({
      type: "SETDATA",
      payload: { name: e.target.name, value: e.target.value },
    });
  };
  // console.log(planPurchase, "planPurchase", isEmailVerified);

  const handleSetOtp = async (value) => {
    dispatch({ type: "SETDATA", payload: { name: "otp", value: value } });
    dispatch({ type: "SETDATA", payload: { name: "otpErr", value: "" } });
    if (value.length == 6) {
      let body = { email: email, otp: value };
      if (!isEmailVerified) {
        body.actionType = "signup";
      } else {
        body.actionType = "post_signup";
      }
      if (!!parentAgency) {
        body.agencyId = parentAgency;
      }

      // console.log(currentPlan, "");
      // return;
      // props.type == "resetPass"

      // props.type == "emailVerification"
      let response = await CallAPI(
        "USER",
        "POST",
        VALIDATE_OTP_URL,
        body,
        false,
        false,
      );
      if (response.status) {
        showToast(response.msg, LABEL.TOAST_TYPE.SUCCESS);
        updateEmailVerified(true);

        if (pendingPlan?.planId && userId) {
          try {
            if (currentPlan) {
              setPlanPurchase(currentPlan);
            }

            const createSubscriptionResponse = await CallAPI(
              "SUBSCRIPTION_IN",
              "POST",
              CMS_BASE_URL.DASHBOARD.USER_SUBSCRIPTION,
              {
                userId: userId,
                planId: planId,
                promotionCode: promotionCode ?? "",
                returnUrl: returnUrl,
              },
            );
            const redirectUrl = createSubscriptionResponse.res?.data?.data?.url;

            if (redirectUrl) {
              clearEmailVerificationFlowStorage({ clearPendingPlan: true });
              window.location.href = redirectUrl;
              return;
            }
          } catch (error) {
            console.log(error);
          }
        }

        if (props.type == "resetPass") {
          dispatch({
            type: "SETDATA",
            payload: { name: "varifivationStatus", value: true },
          });
          // navigate(props.userType == "user" ? "/login" : "/admin/login");
        } else {
          clearEmailVerificationFlowStorage({ clearPendingPlan: true });
          await me();
        }
      } else {
        dispatch({
          type: "SETDATA",
          payload: { name: "otpErr", value: response.msg },
        });
      }
    }
  };

  const handleResetPassword = async () => {
    let flag = true;
    if (!!state.password) {
      if (!validationUtility.passwordCheck(state.password)) {
        flag = false;
        dispatch({
          type: "SETDATA",
          payload: {
            name: "passwordErr",
            value:
              "Password must 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one symbol",
          },
        });
      }
    } else {
      flag = false;
      dispatch({
        type: "SETDATA",
        payload: { name: "passwordErr", value: "Password is required" },
      });
    }

    if (!!state.confirmPassword) {
      if (
        !validationUtility.passwordConfirmCheck(
          state.password,
          state.confirmPassword,
        )
      ) {
        flag = false;
        dispatch({
          type: "SETDATA",
          payload: {
            name: "confirmPasswordErr",
            value: "Confirm password does not match with password",
          },
        });
      }
    } else {
      flag = false;
      dispatch({
        type: "SETDATA",
        payload: {
          name: "confirmPasswordErr",
          value: "Confirm password is required",
        },
      });
    }
    if (!!flag) {
      dispatch({ type: "SETDATA", payload: { name: "loading", value: true } });
      let body = {
        email: email,
        otp: state.otp,
        password: state.password,
        confirmPassword: state.confirmPassword,
      };
      if (!!parentAgency) {
        body.agencyId = parentAgency;
      }
      let response = await CallAPI("USER", "POST", FORGET_PASSWORD_URL, body);
      if (response.status) {
        showToast(response.msg, LABEL.TOAST_TYPE.SUCCESS);
        props.userType == "user"
          ? navigate("/login")
          : navigate("/admin/login");
      } else {
        showToast(response.msg, LABEL.TOAST_TYPE.ERROR);
      }
      dispatch({ type: "SETDATA", payload: { name: "loading", value: false } });
    }
  };

  const ReSendOtp = async () => {
    let URL = !isEmailVerified ? EMAIL_VERIFICATION_OTP : GET_OTP_URL;
    let body = { email: email };
    if (!isEmailVerified) {
      body.actionType = "signup";
    }
    if (!!parentAgency) {
      body.agencyId = parentAgency;
    }
    let response = await CallAPI("USER", "POST", URL, body);
    if (response.status) {
      showToast("OTP resent successfully", LABEL.TOAST_TYPE.SUCCESS);
    } else {
      showToast(response.msg, LABEL.TOAST_TYPE.ERROR);
    }
  };

  const getPlanDetails = async (p) => {
    try {
      const response = await CallAPI(
        "SUBSCRIPTION",
        "GET",
        "subscription/get-plan/" + p,
      );
      setCurrentPlan(response?.res?.data?.data);
    } catch (error) {
      navigate("/pricing");
    }
  };

  useEffect(() => {
    if (planId) {
      getPlanDetails(planId);
    }
  }, [planId]);

  return (
    <div className="form-grid_left">
      <div className="form-grid_gredient">
        <div className="form-grid_block">
          <figure>
            <img
              src={!!parentAgency ? companyInfo?.logo : "/images/bottbuddy.png"}
              alt
            />
          </figure>
          <div className="loginForm">
            <header>
              <h3>
                {props.type == "resetPass"
                  ? "Reset Password"
                  : "Please verify your mail to login"}
              </h3>
            </header>
            <div className="setting-block">
              <div className="change-pass">
                <div className="change-pass_form">
                  {!!state.varifivationStatus ? (
                    props.type == "resetPass" && (
                      <>
                        <div className="field">
                          <label for="txtNewPassword">New Password</label>
                          <div className="changePass-grid">
                            <input
                              type={state.passEyeShow ? "text" : "password"}
                              className="form-control"
                              name="password"
                              value={state.password}
                              placeholder="Enter New Password"
                              onChange={(e) => handleFormInput(e)}
                            />
                            <span
                              className="toggle-password"
                              data-target="txtNewPassword"
                              onClick={() =>
                                dispatch({
                                  type: "SETDATA",
                                  payload: {
                                    name: "passEyeShow",
                                    value: !state.passEyeShow,
                                  },
                                })
                              }
                            >
                              <i
                                className={
                                  state.passEyeShow
                                    ? "fa-regular fa-eye"
                                    : "fa-regular fa-eye-slash"
                                }
                              ></i>
                            </span>
                          </div>
                          {state.passwordErr && (
                            <span>{state.passwordErr}</span>
                          )}
                        </div>
                        <div className="field">
                          <label for="txtConfirmNewPassword">
                            Confirm New Password
                          </label>
                          <div className="changePass-grid">
                            <input
                              type={
                                state.confirmPassEyeShow ? "text" : "password"
                              }
                              value={state.confirmPassword}
                              className="form-control"
                              name="confirmPassword"
                              placeholder="Enter Confirm Password"
                              onChange={(e) => handleFormInput(e)}
                            />
                            <span
                              className="toggle-password"
                              data-target="txtConfirmNewPassword"
                              onClick={() =>
                                dispatch({
                                  type: "SETDATA",
                                  payload: {
                                    name: "confirmPassEyeShow",
                                    value: !state.confirmPassEyeShow,
                                  },
                                })
                              }
                            >
                              <i
                                className={
                                  state.confirmPassEyeShow
                                    ? "fa-regular fa-eye"
                                    : "fa-regular fa-eye-slash"
                                }
                              ></i>
                            </span>
                            {state.confirmPasswordErr && (
                              <span>{state.confirmPasswordErr}</span>
                            )}
                          </div>
                        </div>
                        <div className="field text-center">
                          <a
                            href="#"
                            disabled={!!state.loading}
                            className="cta-green"
                            onClick={() => handleResetPassword()}
                          >
                            {!!state.loading && (
                              <i className="fa-solid fa-spinner fa-spin"></i>
                            )}
                            Reset Password
                          </a>
                        </div>
                      </>
                    )
                  ) : (
                    <OtpView
                      EmailOrPhone={email}
                      handleSetOtp={handleSetOtp}
                      ReSendOtp={ReSendOtp}
                      otp={state.otp}
                      otpErr={state.otpErr}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
